module.exports = __webpack_public_path__ + "img/Schedule.a0bb4161.svg";